AppName.Modules.ThemeModule = (function() {
  //Dependencies
  var core = AppName.Core;

  //////////////////////
  // Private Methods //
  ////////////////////
  var _productImg = function() {
    var product = $('.product-img'),
        scrollproduct = $('.scroll-product-img'),
        button = $('.scroll-button');
        productParent = product.closest('.container'),
        sectionwhy = $('.holder-contents');

    if ($('.homepage').length > 0) {
      var stop = $('footer');
      var margin = 50;
      var showbutton = sectionwhy.offset().top;
    }
    if ($('.product-item').length > 0) {
      var stop = $('.section-try-effect');
      var margin = 130;
    }
    var stopPos = stop.offset().top;

    var options = function() {
       if ($(this).scrollTop() >= showbutton - 500) {
        button.css("opacity", "1");
        // scrollproduct.css({"bottom": "35vh", "transform": 'translateY(50%)'});
      }
      if ($(this).scrollTop() <= showbutton - 500) {
        button.css("opacity", "0");
        // scrollproduct.css({"bottom": "50vh", "transform": 'translateY(50%)'});
      }

      if ($('.homepage').length > 0) {

        if ($(this).scrollTop() <= stopPos) {
          productParent.removeClass('is-absolute');
        }
        if ((productParent.offset().top + productParent.height()) - (product.height() + product.offset().top + margin) < 1) {
          productParent.addClass('is-absolute');
        }
      }

      if ($('.product-item').length > 0) {

        if ($(this).scrollTop() <= stopPos) {
          product.removeClass('is-absolute');
        }
        if ((productParent.offset().top + productParent.height()) - (product.height() + product.offset().top + margin) < 1) {
          product.addClass('is-absolute');
        }
      }
    }

    options();

    $(window).scroll(function() {
      options();
    });
  };

  var _animateOnScroll = function() {
    function revealOnScroll() {
      var $window = $(window),
        winHeightPadded = $window.height() * 1.1;

      var scrolled = $window.scrollTop();

      // Showed...
      $('.JSrevealOnScroll:not(.animated)').each(function() {
        var $this = $(this),
          offsetTop = $this.offset().top;

        if (scrolled + winHeightPadded > offsetTop + 100) {
          if ($this.data('timeout')) {
            window.setTimeout(function() {
              $this.addClass('animated ' + $this.data('animation'));
            }, parseInt($this.data('timeout'), 10));
          } else {
            $this.addClass('animated ' + $this.data('animation'));
          }
        }
      });
    }

    revealOnScroll();

    $(window).scroll(function() {
      revealOnScroll();
    });
  };


  var _startSlick = function() {

    $(".slideshow").slick({
      autoplay: true,
      autoplaySpeed: 3500,
      infinite: true,
      dots: false,
      speed: 500,
      fade: true
    });
  };

  $(window).load(function() {
    if ($('.homepage').length > 0 || $('.product-item').length > 0) {
      _productImg();
      _animateOnScroll();
    }

    _startSlick();


    // bioEp.init({
    //   cookieExp: 0,
    //   showOnDelay: 1,
    //   css:  'body{}'
    // });

  });

  /////////////////////
  // Public Methods //
  ///////////////////
  var init = function() {

  };

  return {
    init: init
  };
})();


function Tweet() {
 var configProfile = {
        "profile": {"screenName": 'trygentlebelly'},
        "domId": 'tweetlist',
        "maxTweets": 3,
        "enableLinks": false,
        "showUser": false,
        "showTime": false,
        "showImages": true,
        "lang": 'en'
  };

twitterFetcher.fetch(configProfile);

 var checker = true;

 setInterval(function(){
    if ($('#tweetlist ul').length > 0 && checker == true) {
      var img1 = $( "#tweetlist ul li" ).first().find('.media img').attr('src');
        var img2 = $( "#tweetlist ul li:nth-child(2)" ).first().find('.media img').attr('src');
        var img3 = $( "#tweetlist ul li:nth-child(3)" ).first().find('.media img').attr('src');
         $(".img-instagram").find("img").attr('src', img1);
         $(".img-instagram:nth-child(2)").find("img").attr('src', img2);
         $(".img-instagram:nth-child(3)").find("img").attr('src', img3);

         var linkstrip1 =$("#tweetlist ul li" ).first().find('.twitter_reply_icon').attr('href');
         var link = linkstrip1.split("to=");
         $(".img-instagram").find("a").attr('href', 'https://twitter.com/TryGentleBelly/status/' + link[1]);

          var linkstrip2 =$("#tweetlist ul li:nth-child(2)" ).first().find('.twitter_reply_icon').attr('href');
         var link2 = linkstrip2.split("to=");
         $(".img-instagram:nth-child(2)").find("a").attr('href', 'https://twitter.com/TryGentleBelly/status/' + link2[1]);

         var linkstrip3 =$("#tweetlist ul li:nth-child(3)" ).first().find('.twitter_reply_icon').attr('href');
         var link3 = linkstrip3.split("to=");
         $(".img-instagram:nth-child(3)").find("a").attr('href', 'https://twitter.com/TryGentleBelly/status/' + link3[1]);
      checker = false;
    }
 },10);
}


function TweetBlog() {
 var configProfile2 = {
        "profile": {"screenName": 'trygentlebelly'},
        "domId": 'tweetlistblog',
        "maxTweets": 4,
        "enableLinks": false,
        "showUser": false,
        "showTime": false,
        "showImages": true,
        "lang": 'en'
  };

twitterFetcher.fetch(configProfile2);

 var checker2 = true;

 setInterval(function(){
    if ($('#tweetlistblog ul').length > 0 && checker2 == true) {
      var img1 = $( "#tweetlistblog ul li" ).first().find('.media img').attr('src');
        var img2 = $( "#tweetlistblog ul li:nth-child(2)" ).find('.media img').attr('src');
        var img3 = $( "#tweetlistblog ul li:nth-child(3)" ).find('.media img').attr('src');
        var img4 = $( "#tweetlistblog ul li:nth-child(4)" ).find('.media img').attr('src')
         $(".img-instagram").find("img").attr('src', img1);
         $(".img-instagram:nth-child(2)").find("img").attr('src', img2);
         $(".img-instagram:nth-child(3)").find("img").attr('src', img3);
         $(".img-instagram:nth-child(4)").find("img").attr('src', img4);

         var linkstrip1 =$("#tweetlistblog ul li" ).first().find('.twitter_reply_icon').attr('href');
         var link = linkstrip1.split("to=");
         $(".img-instagram").find("a").attr('href', 'https://twitter.com/TryGentleBelly/status/' + link[1]);

          var linkstrip2 =$("#tweetlistblog ul li:nth-child(2)" ).first().find('.twitter_reply_icon').attr('href');
         var link2 = linkstrip2.split("to=");
         $(".img-instagram:nth-child(2)").find("a").attr('href', 'https://twitter.com/TryGentleBelly/status/' + link2[1]);

         var linkstrip3 =$("#tweetlistblog ul li:nth-child(3)" ).first().find('.twitter_reply_icon').attr('href');
         var link3 = linkstrip3.split("to=");
         $(".img-instagram:nth-child(3)").find("a").attr('href', 'https://twitter.com/TryGentleBelly/status/' + link3[1]);

         var linkstrip4 =$("#tweetlistblog ul li:nth-child(4)" ).first().find('.twitter_reply_icon').attr('href');
         var link4 = linkstrip4.split("to=");
         $(".img-instagram:nth-child(3)").find("a").attr('href', 'https://twitter.com/TryGentleBelly/status/' + link4[1]);

      checker2 = false;
    }
 },10);
}